import type { AppConfig } from 'modules/config/appConfig';
import { AnalyticsService } from './services/AnalyticsService';
import { ApiService } from './services/ApiService';
import { AuthService } from './services/AuthService';
import { CmsService } from './services/CmsService';
import { CookieService } from './services/CookieService';

const authService = new AuthService();
const apiService = new ApiService();
const analyticsService = new AnalyticsService();
const cookieService = new CookieService();
const cmsService = new CmsService();

const bootstrap = (config: AppConfig) => {
  authService.init(config);
  apiService.init(config.apiBaseUrl, authService);
  cmsService.init(config);
};

export { bootstrap as default, apiService, authService, analyticsService, cookieService, cmsService };
